import { Type } from '@angular/core';
import { GameId } from 'src/app/model/game/game-id';
import type { GameUiComponent } from './game-ui-component.interface';
import type { UxGameController } from '../../controllers/game-legacy/ux-game-controller';
import type { GenericSceneController } from '../../controllers/scene-controllers/scene-controller-factory';

type GameUiControlComponent = Type<GameUiComponent<UxGameController | GenericSceneController>>;

// Async loader functions for lazy loading game UI components
export const GameUiControlLoaders: Record<GameId, () => Promise<GameUiControlComponent>> = {
  [GameId.Blackjack]: async () => {
    const { BlackjackGameControlsComponent } = await import(
      /* webpackChunkName: "ui-blackjack" */
      '../controls/blackjack-game-controls/blackjack-game-controls.component'
    );
    return BlackjackGameControlsComponent;
  },
  [GameId.Blocks]: async () => {
    const { BlocksGameControlsComponent } = await import(
      /* webpackChunkName: "ui-blocks" */
      '../controls/blocks-game-controls/blocks-game-controls.component'
    );
    return BlocksGameControlsComponent;
  },
  [GameId.Marbles]: async () => {
    const { MarblesGameControlsComponent } = await import(
      /* webpackChunkName: "ui-marbles" */
      '../controls/marbles-game-controls/marbles-game-controls.component'
    );
    return MarblesGameControlsComponent;
  },
  [GameId.Solitaire]: async () => {
    const { SolitaireGameControlsComponent } = await import(
      /* webpackChunkName: "ui-solitaire" */
      '../controls/solitaire-game-controls/solitaire-game-controls.component'
    );
    return SolitaireGameControlsComponent;
  },
  [GameId.TwentyOne]: async () => {
    const { TwentyOneGameControlsComponent } = await import(
      /* webpackChunkName: "ui-twentyone" */
      '../controls/twentyone-game-controls/twentyone-game-controls.component'
    );
    return TwentyOneGameControlsComponent;
  },
  [GameId.Slots]: async () => {
    const { SlotsSceneGameControlsComponent } = await import(
      /* webpackChunkName: "ui-slots" */
      '../controls/slots-scene-game-controls/slots-scene-game-controls.component'
    );
    return SlotsSceneGameControlsComponent;
  },
  [GameId.Plinko]: async () => {
    const { PlinkoGameControlsComponent } = await import(
      /* webpackChunkName: "ui-plinko" */
      '../controls/plinko-game-controls/plinko-game-controls.component'
    );
    return PlinkoGameControlsComponent;
  },
  [GameId.VideoPoker]: async () => {
    const { VideoPokerGameControlsComponent } = await import(
      /* webpackChunkName: "ui-videopoker" */
      '../controls/videopoker-game-controls/videopoker-game-controls.component'
    );
    return VideoPokerGameControlsComponent;
  },
  [GameId.HiLo]: async () => {
    const { HiLoGameControlsComponent } = await import(
      /* webpackChunkName: "ui-hilo" */
      '../controls/hilo-game-controls/hilo-game-controls.component'
    );
    return HiLoGameControlsComponent;
  },
};
